var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _c(
        "b-form-checkbox",
        {
          attrs: { checked: _vm.isActive, disabled: _vm.value.amount === 0 },
          on: { change: _vm.setOrUnsetValue }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.value.label) +
              " (" +
              _vm._s(_vm.value.amount) +
              ")\n\t"
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }